module.exports = __webpack_public_path__ + "img/candling_infographic.cc83e54c.svg";